import React from 'react'
import { navigate } from 'gatsby'
import { Box, Button, Text, GridView } from '@planning-center/ui-kit'

import '../css/global-styles.css'

const Index = () => (
  <GridView
    justifyItems="center"
    rows="1fr 250px auto 32px auto 2fr"
    minHeight="100vh"
    textAlign="center"
    backgroundColor="hsl(200,10%,8%)"
  >
    <Box
      as="svg"
      row={2}
      width="296px"
      height="250px"
      viewBox="0 0 296 250"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.3 196.032C107.938 195.457 108.321 194.498 108.321 193.092V174.107H114.445V192.58C114.445 195.521 113.616 197.95 111.766 199.675C109.916 201.401 107.3 202.168 104.11 202.168C100.921 202.168 98.3052 201.465 96.4552 199.739C94.6052 198.014 93.7759 195.585 93.7759 192.644V174.107H99.9V193.092C99.9 194.498 100.283 195.457 100.921 196.032C101.622 196.607 102.579 196.991 104.11 196.991C105.641 196.991 106.662 196.607 107.3 196.032ZM126.183 174.107H120.059V201.785H126.183V174.107ZM179.897 174.107V179.413H187.998V201.785H194.122V179.413H202.224V174.107H179.897ZM156.995 174.107H164.331L152.593 187.531L165.479 201.785H157.569L148.447 191.43V201.785H142.322V174.107H148.447V184.143L156.995 174.107ZM174.985 174.107H168.86V201.785H174.985V174.107Z"
        fill="#E8641F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.7759 47.8316V98.1232C93.7759 129.521 118.053 148.597 148 148.597C177.947 148.597 202.224 129.521 202.224 98.1232V47.8316H93.7759ZM156.665 90.5366L171.603 63.1378H141.726L124.397 102.279H142.323V133.291L171.305 90.5366H156.665Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="148"
          y1="47.8316"
          x2="148"
          y2="148.597"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD057" />
          <stop offset="0.895833" stopColor="#E8641F" />
        </linearGradient>
      </defs>
    </Box>
    <Text row={3} size={24} maxWidth={60} lineHeight="1.4" color="light-8">
      A collection of flexible React components that help you build resilient,
      accessible user interfaces quickly and effectively.
    </Text>
    <Button
      row={5}
      title="Get Started"
      size="lg"
      theme={false}
      backgroundColor="#E8641F"
      color="light-9"
      onClick={() => navigate('/getting-started')}
    />
  </GridView>
)

export default Index
